// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/footer.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding: 100px 0px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-bottom: 10px solid #977cff;
}

.footer a,
.footer a:hover {
  color: #ffffff;
}

.footer h3 {
  font-family: "Poppins";
  color: #7380ff;
  font-size: 26px;
  text-transform: uppercase;
  text-align: left;
  font-weight: 700;
}

.footer ul {
  padding: 0px;
  margin-top: 20px;
}

.footer ul li {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 15px;
  list-style: none;
  text-align: left;
  color: #ffffff;
}

.footer_overlay_bg {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 25px;
  margin: 0 auto;
  justify-content: center;
  border-radius: 15px;
  background: var(--dPink);
  mix-blend-mode: screen;
  width: 50%;
}

.footer_overlay_bg_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.footer_overlay_bg_item div {
  display: flex;
  flex-direction: row;
  margin-left: 40px;
}

.footer_overlay_bg_item div a {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  margin-right: 58px;
}

.footer_overlay_bg_item h3 {
  color: #ffffff;
  font-size: 22px;
  font-weight: 400;
  text-transform: none;
  margin: 0px;
}

a.footer_overlay_bg_btn {
  border-radius: 25px;
  background: var(--dPink);
  color: #ffffff;
  padding: 15px 40px;
}

.footer_social_link {
  margin-top: 50px;
}

.footer_social_link svg {
  color: var(--dPink);
}

.footer_social_link div {
  margin-left: 40px;
}
.footer_social_link div svg {
  margin-left: 20px;
}

.color-white {
  color: #ffffff;
}
.footer_icons {
  margin-left: 50px;
}

.footer_icons a:not(:first-child) {
  margin-left: 15px;
  /* font-size: 20px; */
}

/* .footer_icons a:first-child {
  padding-left: 15px;
} */

.footer_icons a {
  border: 1px solid white;
  border-radius: 50%;
  padding: 4px 7px;
}

.footer_icons a svg {
  font-size: 16px;
  color: var(--white);
}

/* floating icons */
.fl-fl {
  text-transform: uppercase;
  background: var(--dBlue);
  right: -125px;
  padding: 5px;
  width: 170px;
  margin-bottom: 5px;
  z-index: 1000;
  transition: all 0.25s ease;
  border-radius: 0px;
}
.fl-fl:nth-child(1) {
  position: fixed;
  top: 40%;
  padding: 10px;
}
.float-sm a {
  color: #ffffff;
  text-decoration: none !important;
}
.fl-fl:nth-child(1) span {
  margin-left: 10px;
}
.float-sm {
  position: relative;
  z-index: 5;
}

.fl-fl:nth-child(1):hover {
  right: -10px;
}

.contact-btn-footer a button {
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor;
  border: initial;
  font-weight: 700;
}

.footer-cta:hover {
  background-color: var(--dPink) !important;
}

@media (max-width: 1024px) {
  .footer_overlay_bg_item div a {
    margin-right: 40px !important;
  }

  .footer_icons {
    margin-left: 40px !important;
  }

  .footer_overlay_bg {
    padding: 30px 40px;
    margin-top: 25px;
  }

  .footer {
    padding: 50px 0px;
  }
}

/* floating icons end*/
@media only screen and (max-width: 576px) {
  .footer_overlay_bg {
    width: 100%;
    padding: 20px 30px;
  }

  .footer_overlay_bg_item h3 {
    font-size: 22px !important;
  }

  .footer_overlay_bg,
  .footer_overlay_bg_item {
    flex-wrap: wrap;
    flex-direction: column;
  }

  .footer_overlay_bg {
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  a.footer_overlay_bg_btn {
    padding: 10px 30px;
  }

  .footer_overlay_bg_item div a {
    font-size: 15px;
  }

  /* .footer_overlay_bg_item h3 {
    margin-bottom: 20px;
  } */

  .fl-fl {
    width: 170px;
  }

  .footer h3 {
    font-size: 15px;
  }

  .footer ul li {
    font-size: 14px;
  }

  .footer_overlay_bg_item div {
    margin: 0px;
    display: flex;
    justify-content: space-around;
  }
  .footer_overlay_bg_item div a {
    font-size: 14px;
    font-weight: 500;
    margin: 0px 5px;
    margin-right: 0 !important;
    margin-right: initial !important;
  }
  .footer_overlay_bg_item div {
    margin: 0px;
    column-gap: 20px;
  }
  .footer_icons {
    margin-top: 20px;
    margin-left: 0px !important;
  }

  /* .footer_icons a:first-child {
    padding-left: 0px;
  } */
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .footer_overlay_bg {
    width: 60%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/Footer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yDAAuD;EACvD,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EAKb,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAAuB;EAAvB,yBAAuB;EACvB,gCAAa;EAAb,eAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA8B;IAA9B,gCAA8B;EAChC;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;;KAEG;AACL;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".footer {\r\n  padding: 100px 0px;\r\n  background-image: url(\"../../public/images/footer.jpg\");\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  border-bottom: 10px solid #977cff;\r\n}\r\n\r\n.footer a,\r\n.footer a:hover {\r\n  color: #ffffff;\r\n}\r\n\r\n.footer h3 {\r\n  font-family: \"Poppins\";\r\n  color: #7380ff;\r\n  font-size: 26px;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n  font-weight: 700;\r\n}\r\n\r\n.footer ul {\r\n  padding: 0px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.footer ul li {\r\n  font-family: \"Poppins\";\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  list-style: none;\r\n  text-align: left;\r\n  color: #ffffff;\r\n}\r\n\r\n.footer_overlay_bg {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  padding: 25px;\r\n  margin: 0 auto;\r\n  justify-content: center;\r\n  border-radius: 15px;\r\n  background: var(--dPink);\r\n  mix-blend-mode: screen;\r\n  width: 50%;\r\n}\r\n\r\n.footer_overlay_bg_item {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n}\r\n\r\n.footer_overlay_bg_item div {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-left: 40px;\r\n}\r\n\r\n.footer_overlay_bg_item div a {\r\n  color: #ffffff;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  margin-right: 58px;\r\n}\r\n\r\n.footer_overlay_bg_item h3 {\r\n  color: #ffffff;\r\n  font-size: 22px;\r\n  font-weight: 400;\r\n  text-transform: none;\r\n  margin: 0px;\r\n}\r\n\r\na.footer_overlay_bg_btn {\r\n  border-radius: 25px;\r\n  background: var(--dPink);\r\n  color: #ffffff;\r\n  padding: 15px 40px;\r\n}\r\n\r\n.footer_social_link {\r\n  margin-top: 50px;\r\n}\r\n\r\n.footer_social_link svg {\r\n  color: var(--dPink);\r\n}\r\n\r\n.footer_social_link div {\r\n  margin-left: 40px;\r\n}\r\n.footer_social_link div svg {\r\n  margin-left: 20px;\r\n}\r\n\r\n.color-white {\r\n  color: #ffffff;\r\n}\r\n.footer_icons {\r\n  margin-left: 50px;\r\n}\r\n\r\n.footer_icons a:not(:first-child) {\r\n  margin-left: 15px;\r\n  /* font-size: 20px; */\r\n}\r\n\r\n/* .footer_icons a:first-child {\r\n  padding-left: 15px;\r\n} */\r\n\r\n.footer_icons a {\r\n  border: 1px solid white;\r\n  border-radius: 50%;\r\n  padding: 4px 7px;\r\n}\r\n\r\n.footer_icons a svg {\r\n  font-size: 16px;\r\n  color: var(--white);\r\n}\r\n\r\n/* floating icons */\r\n.fl-fl {\r\n  text-transform: uppercase;\r\n  background: var(--dBlue);\r\n  right: -125px;\r\n  padding: 5px;\r\n  width: 170px;\r\n  margin-bottom: 5px;\r\n  z-index: 1000;\r\n  -webkit-transition: all 0.25s ease;\r\n  -moz-transition: all 0.25s ease;\r\n  -ms-transition: all 0.25s ease;\r\n  -o-transition: all 0.25s ease;\r\n  transition: all 0.25s ease;\r\n  border-radius: 0px;\r\n}\r\n.fl-fl:nth-child(1) {\r\n  position: fixed;\r\n  top: 40%;\r\n  padding: 10px;\r\n}\r\n.float-sm a {\r\n  color: #ffffff;\r\n  text-decoration: none !important;\r\n}\r\n.fl-fl:nth-child(1) span {\r\n  margin-left: 10px;\r\n}\r\n.float-sm {\r\n  position: relative;\r\n  z-index: 5;\r\n}\r\n\r\n.fl-fl:nth-child(1):hover {\r\n  right: -10px;\r\n}\r\n\r\n.contact-btn-footer a button {\r\n  background-color: unset;\r\n  border: unset;\r\n  font-weight: 700;\r\n}\r\n\r\n.footer-cta:hover {\r\n  background-color: var(--dPink) !important;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .footer_overlay_bg_item div a {\r\n    margin-right: 40px !important;\r\n  }\r\n\r\n  .footer_icons {\r\n    margin-left: 40px !important;\r\n  }\r\n\r\n  .footer_overlay_bg {\r\n    padding: 30px 40px;\r\n    margin-top: 25px;\r\n  }\r\n\r\n  .footer {\r\n    padding: 50px 0px;\r\n  }\r\n}\r\n\r\n/* floating icons end*/\r\n@media only screen and (max-width: 576px) {\r\n  .footer_overlay_bg {\r\n    width: 100%;\r\n    padding: 20px 30px;\r\n  }\r\n\r\n  .footer_overlay_bg_item h3 {\r\n    font-size: 22px !important;\r\n  }\r\n\r\n  .footer_overlay_bg,\r\n  .footer_overlay_bg_item {\r\n    flex-wrap: wrap;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .footer_overlay_bg {\r\n    flex-wrap: wrap;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  a.footer_overlay_bg_btn {\r\n    padding: 10px 30px;\r\n  }\r\n\r\n  .footer_overlay_bg_item div a {\r\n    font-size: 15px;\r\n  }\r\n\r\n  /* .footer_overlay_bg_item h3 {\r\n    margin-bottom: 20px;\r\n  } */\r\n\r\n  .fl-fl {\r\n    width: 170px;\r\n  }\r\n\r\n  .footer h3 {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .footer ul li {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .footer_overlay_bg_item div {\r\n    margin: 0px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n  }\r\n  .footer_overlay_bg_item div a {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    margin: 0px 5px;\r\n    margin-right: unset !important;\r\n  }\r\n  .footer_overlay_bg_item div {\r\n    margin: 0px;\r\n    column-gap: 20px;\r\n  }\r\n  .footer_icons {\r\n    margin-top: 20px;\r\n    margin-left: 0px !important;\r\n  }\r\n\r\n  /* .footer_icons a:first-child {\r\n    padding-left: 0px;\r\n  } */\r\n}\r\n\r\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\r\n  .footer_overlay_bg {\r\n    width: 60%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
